import {randomNumberRange} from '@coolcolduk/util';
import {ResultMotionItem} from './createResultMotion';
import getWindowDimensions from './util/getWindowDimensions';

const faces = ['😢', '😭', '😞', '😔', '🥺', '😥', '😪', '😰', '😨'];

export interface GenerateSadFaceArrayProps {
  count?: number;
  durationSecs?: number;
  delaySecs?: number;
}

export default function generateSadFaceArray({
  count = 20,
  durationSecs = 2 + Math.random() * 1.5,
  delaySecs = Math.random() * 0.3,
}: GenerateSadFaceArrayProps = {}): ResultMotionItem[] {
  const {width, height} = getWindowDimensions();

  return [...Array(count)].map((_, i) => {
    const randomStartX = randomNumberRange(0.1, 0.9, true);
    const randomStartY = randomNumberRange(-0.2, 0.1, true); // Start closer to viewport
    const randomEndX = randomNumberRange(0.1, 0.9, true);
    const randomEndY = randomNumberRange(0.7, 1.0, true); // End within viewport

    const randomScale = 1.0 + Math.random() * 1.0; // Make them bigger
    const randomRotation = (Math.random() - 0.5) * 30; // Less rotation for better visibility

    return {
      initial: {
        x: randomStartX * width,
        y: randomStartY * height,
        opacity: 0,
        scale: 0,
        rotate: randomRotation,
      },
      animate: {
        x: randomEndX * width,
        y: randomEndY * height,
        opacity: [0, 0.8, 1, 1, 1, 0.6, 0],
        scale: [0, randomScale * 0.6, randomScale, randomScale, randomScale, randomScale * 0.8, 0.3],
        rotate: randomRotation + (Math.random() - 0.5) * 20,
      },
      transition: {
        duration: durationSecs,
        delay: delaySecs,
        ease: 'easeInOut',
        times: [0, 0.1, 0.3, 0.5, 0.7, 0.9, 1],
      },
      style: {
        position: 'absolute',
        fontSize: '2.2rem',
      },
      text: faces[i % faces.length],
    };
  });
}
